"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HamianProfile {
    constructor(data = {}) {
        this.firstName = '';
        this.lastName = '';
        this.phone = '';
        this.token = '';
        this.wallet = [];
        Object.assign(this, data);
    }
}
exports.default = HamianProfile;
